<template>
    <f7-page name="home">
        <f7-navbar title="Home"></f7-navbar>
        <!-- Page content -->
        home

        <f7-link href="/login">Login Page</f7-link>
    </f7-page>
</template>
<script>
    //import auth from '../../auth/auth'
    //import Routes from '../../routes';

    export default {
       /* created() {
            auth.checkAuth()
            console.log(auth);
            if (auth.authenticated && userType == 'user') {
                console.log('logged in correctly');
                var currentPage = JSON.parse(localStorage.getItem('currentPage'))
                /!* if(currentPage.page) {
                     this.page = currentPage.page
                     this.pageTitle = currentPage.title
                 } else {
                     this.page = 'select-date'
                     this.pageTitle = 'Choose Date'
                 }*!/
                this.showNav = true
            } else {
                console.log('do logout');
                auth.logout()
                //this.Router.push('Login')
                //this.page = '/login'
                /!*this.hideNav = true
                this.showNav = false
                this.showLoader = false*!/
            }
        }*/
    }
</script>
